/**
 * @typedef {"/machine-config" | "/networkConfig" | "/jogger" | "/machine-logic" | "/ui-builder" | "/appLauncher" | "/menu" | "/check-config"} PendantPage
 */
export const Pages = Object.freeze({
  MACHINE_CONFIG: '/machine-config',
  NETWORK_CONFIG: '/networkConfig',
  JOGGER: '/jogger',
  MACHINE_LOGIC: '/machine-logic',
  UI_BUILDER: '/ui-builder',
  APP_LAUNCHER: '/appLauncher',
  MENU: '/menu',
  CONFIG_CHECKER: '/check-config',
  ONBOARDING: '/onboarding',
  MACHINE_APP: '/machine-app',
  REMOTE_SUPPORT: '/remote-support',
});
